
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 13.14a.48.48 0 00-.48.48v5.8a.48.48 0 10.95 0v-5.8a.48.48 0 00-.48-.48zm3.03 0a.48.48 0 00-.47.48v5.8a.48.48 0 00.95 0v-5.8a.48.48 0 00-.48-.48zm-6.08 0a.48.48 0 00-.48.48v5.8a.48.48 0 00.96 0v-5.8a.48.48 0 00-.48-.48z","fill":"#1E1E1E"}}),_c('path',{attrs:{"d":"M18.84 3.43h-2.72V2.05c0-.58-.47-1.05-1.05-1.05H9.91c-.58 0-1.05.47-1.05 1.05v1.39H6.14a2.14 2.14 0 00-.7 4.16.4.4 0 00-.01.1v12.92A2.38 2.38 0 007.8 23h9.39a2.38 2.38 0 002.37-2.38V7.71l-.01-.1a2.15 2.15 0 00-.71-4.18zM9.82 2.05c0-.05.04-.1.1-.1h5.16c.05 0 .1.05.1.1v1.39H9.82V2.05zm7.36 20H7.8c-.79 0-1.42-.64-1.42-1.43V7.72H18.6v12.9c0 .8-.64 1.43-1.43 1.43zm1.66-15.28H6.14a1.2 1.2 0 110-2.38h12.7a1.2 1.2 0 110 2.38z","fill":"#1E1E1E"}})])
          )
        }
      }
    